import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { ScrollView } from '../../../../common/components/atoms';
import { wait } from '../../../../common/helper/commonHelper.js';
import speedIcon from '../../../components/atoms/data/speed-icon.svg';

class Training3 extends Component {
    constructor(props) {
        super(props);

        this.refAudio = React.createRef();
        this.refScroll = React.createRef();
        this.testIndex = 0;
        this.autoplayIndex = 0;
        this.currentAudio = -1; // 再生中音声
        this.currentAudioIndex = -1; // 再生中インデックス
        this.state = {
            displayEnglish: true,
            displayJapanese: true,
            executeTest: 0,
            executeAutoPlay: 0,
            test: [],
            audios: [],
            loadedAudio: 0,
            loading: true,
            setting: false,
            playbackRate: this.props.playbackRate ? this.props.playbackRate : 1,
            executeTap: 0, // 再生中チャンク
        }
    }

    componentDidMount() {
        this.reset();
    }

    loadStart = () => {
        if (this.props.chunk.length === 0) {
            this.setState({
                loading: false
            });
            return;
        }
        for (let key in this.props.chunk) {
            if (this.props.chunk[key].audio) {
                this.props.dispatch({
                    type: "DownloadAudio_Saga",
                    subjectID: this.props.subject.id,
                    id: key,
                    name: this.props.chunk[key].audio,
                    mode: 0,
                    onSuccess: this.onSuccessAudio,
                    onFailure: this.onFailure,
                });
            } else {
                let loadedAudio = this.state.loadedAudio + 1;
                this.setState({
                    loadedAudio: loadedAudio,
                    loading: !this.checkLoadEnded(loadedAudio)
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isCurrent && !this.props.isCurrent) {
            this.refAudio.current.pause();
            if (this.state.executeAutoPlay === 1 || this.state.executeTest === 1 || this.state.executeTap === 1) {
                this.autoplayIndex = 0;
                this.testIndex = 0;
                this.currentAudio = -1; // タップ再生英語音声
                this.currentAudioIndex = -1; // タップ再生日本語訳
                let test = this.state.test;
                for (let key in this.props.chunk) {
                    test[key] = 0;
                }

                this.stop();
                this.setState({
                    executeAutoPlay: 0,
                    executeTest: 0,
                    test: test,
                    executeTap: 0, // タップ再生(0:停止、1:実行)
                });
            }
        }
        if (prevState.loading && !this.state.loading) {
            if (!this.state.loading) {
                let test = this.state.test;
                for (let key in this.props.chunk) {
                    test[key] = 0;
                }
                this.setState({
                    test: test
                });
            }
        }
    }

    checkLoadEnded = (loadedAudio) => {
        if (loadedAudio < Object.keys(this.props.chunk).length) {
            return false;
        }
        return true;
    }

    onSuccessAudio = (audio, id) => {
        let audios = this.state.audios;
        let loadedAudio = this.state.loadedAudio + 1;
        audios[id] = audio;
        this.setState({
            audios: audios,
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }
    onFailure = (status, error) => {
        let loadedAudio = this.state.loadedAudio + 1;
        this.setState({
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }

    getSortedList(list) {
        list.sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
        });
        return list;
    }

    reset() {
        let test = [];
        let audios = [];
        for (let key in this.props.chunk) {
            test[key] = 0;
            audios[key] = "";
        }
        this.testIndex = 0;
        this.autoplayIndex = 0;
        this.currentAudio = -1; // タップ再生英語音声
        this.currentAudioIndex = -1; // タップ再生日本語訳
        this.setState({
            test: test,
            audios: audios,
            loadedAudio: 0,
            loading: true,
            executeTest: 0,
            executeAutoPlay: 0,
            executeTap: 0, // タップ再生(0:停止、1:実行)
        });
    }

    onClickPlay(e, index) {
        if (this.state.executeAutoPlay === 1){
            this.stop();
            this.onClickAllPlay(e, index);
        }else if (this.state.executeTest === 1){
            this.stop();
            this.onClickTest(e, index);
        } else if (this.state.executeTap === 1){
            this.stop();
            this.currentAudio = index; // タップ再生英語音声
            this.currentAudioIndex = index - 1; // タップ再生日本語訳
            this.onClickTapPlay(e);
        }else {
            this.setActive(index);
            this.play(index);
        }
    }

    setActive(index) {
        this.setState({ active: index });
        setTimeout((e) => {
            this.setState({ active: -1 });
        }, 300);
    }

    play(index) {
        try {
            if (this.state.audios[index]) {
                this.refAudio.current.src = this.state.audios[index];
                this.refAudio.current.load();
                this.refAudio.current.playbackRate = this.state.playbackRate;
                this.refAudio.current.play();
            }
        } catch (e) {
        }
    }
    stop() {
        this.refAudio.current.pause();
    }

    createText() {
        let ret = [];
        let index = 0;
        let active = 0;
        for (let key in this.props.chunk) {
            if (this.state.active === index) {
                active = 1;
            } else {
                active = 0;
            }
            const i = index;
            ret.push(
                <WordRow id={"#chunk" + key} key={index} onClick={e => this.onClickPlay(e, i)} active={active}>
                    <Word type={1} Display={1}>
                        <WordRowIcon>
                            <i className="far fa-play-circle" />
                        </WordRowIcon>
                        <WordRowChild Display={this.state.displayEnglish}>
                            {this.props.chunk[key].textEn}
                        </WordRowChild>
                    </Word>
                    <Word Display={this.state.displayJapanese && this.state.test[key] === 0}>
                        {this.props.chunk[key].textJp}
                    </Word>
                </WordRow>
            )
            index++;

        }

        return ret;
    }

    onClickLanguage(e, index) {
        if (index === 0) {
            if (this.state.displayEnglish) {
                if (this.state.executeTest === 1 || this.state.executeTap === 1) return;

                this.setState({ displayEnglish: false });
            } else {
                this.setState({ displayEnglish: true });
            }
        } else {
            if (this.state.displayJapanese) {
                if (this.state.executeTest === 1|| this.state.executeTap === 1) return;

                this.setState({ displayJapanese: false });
            } else {
                this.setState({ displayJapanese: true });
            }
        }
    }

    onClickAllPlay = (e, index) => {
        if (this.state.executeTest === 1){
            this.onClickTestEnd();
        }
        if (this.state.executeTap === 1){
            this.onClickTapPlayEnd();
        }
        this.autoplayIndex = index;
        if (index === 0){ this.refScroll.current.scrollTo(0); }

        this.play(this.autoplayIndex);
        this.setActive(this.autoplayIndex);
        this.setState({ executeAutoPlay: 1 });
    }
    onClickAllStop = (e) => {
        if (this.state.executeAutoPlay === 1) {
            this.autoplayIndex = 0;

            this.stop();
            this.setState({ executeAutoPlay: 0 });
        }
    }

    onClickTest = (e, index) => {
        if (this.state.executeAutoPlay === 1){
            this.onClickAllStop();
        }
        if (this.state.executeTap === 1){
            this.onClickTapPlayEnd();
        }
        this.testIndex = index;
        if (index === 0){ this.refScroll.current.scrollTo(0); }

        this.play(this.testIndex);

        let test = this.state.test;
        for (let key in this.props.chunk) {
            if (key < index) {
                test[key] = 0;
            } else {
                test[key] = 1;
            }
        }
        this.setState({
            displayEnglish: true,
            displayJapanese: true,
            executeTest: 1,
            test: test
        });
    }
    onClickTestEnd = (e) => {
        if (this.state.executeTest === 1) {
            this.testIndex = 0;

            this.stop();

            let test = this.state.test;
            for (let key in this.props.chunk) {
                test[key] = 0;
            }
            this.setState({ executeTest: 0, test: test });
        }
    }

    // タップ再生
    onClickTapPlay = (e) => {
        //オート再生実行中の場合、オート再生を終了する
        if (this.state.executeTest === 1){
            this.onClickTestEnd();
        }
        //まとめ再生実行中の場合、まとめ再生を終了する
        if (this.state.executeAutoPlay === 1){
            this.onClickAllStop();
        }
        this.setState({
            executeTap: 1, //タップ再生ON
            displayEnglish: true
        });
        let nextAudio = this.currentAudio;
        let nextIndex = this.currentAudioIndex;
        let test = this.state.test;

        //タップ再生ボタンを押して1回目の処理
        if (nextAudio === -1){
            this.refScroll.current.scrollTo(0); //ページ先頭にスクロール
            for (let key in this.props.chunk) { //チャンク日本語を全て非表示
                test[key] = 1;
            }
            nextAudio++; //1つ目のチャンク音声を再生するよう指定
        }
        const { chunk } = this.props;
        //チャンク日本語の表示・非表示
        for (let key in chunk) {
            if (key <= nextIndex) {
                test[key] = 0; //表示
            } else {
                test[key] = 1; //非表示
            }
        }
        if (nextAudio > nextIndex) {
          this.play(nextAudio); //チャンク音声を再生
          nextIndex++; //次のチャンク日本語を指定
        } else {
          nextAudio++; //次のチャンク音声を指定
        }

        let nextExecuteTap = 1;
        if (nextIndex === chunk.length) {
            nextExecuteTap = 0;
            nextIndex = -1;
            nextAudio = -1;
            this.refScroll.current.scrollTo(0)
        }

        this.currentAudio = nextAudio; // 再生中音声
        this.currentAudioIndex = nextIndex; // 再生中インデックス
        this.setState(prevState => ({
          displayEnglish: true,
          displayJapanese: true,
          test: test,
          executeTap: nextExecuteTap,
        }));
      }

    // チャンクの順番実行を終了
    onClickTapPlayEnd = (e) => {
        if (this.state.executeTap === 1) {
            this.stop();
            let test = this.state.test;
            for (let key in this.props.chunk) {
                test[key] = 0;
            }
            this.currentAudio = -1; // 再生中音声
            this.currentAudioIndex = -1; // 再生中インデックス
            this.setState({
                executeTap: 0,
                test: test,
            });
        }
    }

    onEnded = (e) => {
        const max = Object.keys(this.props.chunk).length;

        // 再生時のインターバル設定
        let testDisplayInterval = 3000;     // 英語を読んでから日本語を表示するまでのインターバル
        let testPlayInterval = 2000;        // 日本語が表示されてから次の英語を読むまでのインターバル
        let autoPlaytestInterval = 4000;    // まとめて再生時のインターバル

        // インターバルに速度調整を適用
        let playbackRate = this.state.playbackRate;
        testDisplayInterval = Math.floor(testDisplayInterval / playbackRate);
        testPlayInterval = Math.floor(testPlayInterval / playbackRate);
        autoPlaytestInterval = Math.floor(autoPlaytestInterval / playbackRate);

        if (this.state.executeTest === 1) {
            (async() => {
                let test = this.state.test;
                test[this.testIndex] = 0;
                await wait(testDisplayInterval);
                this.setState({ test: test });

                this.testIndex++;
                if (this.testIndex === max) {
                    this.setState({ executeTest: 0 });
                } else {
                    let a = document.getElementById("#chunk" + this.testIndex).getBoundingClientRect();
                    let height = this.refScroll.current.getBodyHeight();
                    if ((a.top + a.height) > (height + 110)) {
                        this.refScroll.current.scroll(a.height);
                    }
                    await wait(testPlayInterval);
                    if (this.state.executeTest === 1) {
                        this.play(this.testIndex);
                    }
                }
            })()
        }
        if (this.state.executeAutoPlay === 1) {
            this.autoplayIndex++;
            if (this.autoplayIndex === max) {
                this.setState({ executeAutoPlay: 0 });
            } else {
                (async() => {
                    await wait(autoPlaytestInterval);
                    if (this.state.executeAutoPlay === 1) {
                        let a = document.getElementById("#chunk" + this.autoplayIndex).getBoundingClientRect();
                        let height = this.refScroll.current.getBodyHeight();
                        if ((a.top + a.height) > (height + 64)) {
                            this.refScroll.current.scroll(a.height);
                        }
                        this.setActive(this.autoplayIndex);
                        this.play(this.autoplayIndex);
                        }
                })()
            }
        }
        // 自動でスクロールし、日本語訳を表示する
        if (this.state.executeTap === 1) {
            let a = document.getElementById("#chunk" + this.currentAudioIndex).getBoundingClientRect();
            let height = this.refScroll.current.getBodyHeight();
            if ((a.top + a.height) > (height + 110)) {
                this.refScroll.current.scroll(a.height);
            }
        }
    }

    onClickSettingbutton = (e) => {
        if (this.state.setting) {
            this.setState({ setting: false });
        } else {
            this.setState({ setting: true });
        }
    }
    onClickSelector = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const rate = Number(e.target.innerText);
        this.refAudio.current.playbackRate = rate;
        this.setState({ 
            playbackRate: rate, 
            setting: false 
        });

        if (this.props.onChangePlaybackRate) {
            this.props.onChangePlaybackRate(rate);
        }
    }
    createSpeedSelector() {
        let speed = 0.5;
        let selector = [];
        while (1) {
            let text = (speed + '.0').slice(0, 3);
            let style = speed === this.state.playbackRate ? { backgroundColor: "#f9f9f9" } : { background: "transparent" };
            selector.push(
                <Speed key={speed} style={style} onClick={this.onClickSelector}>{text}</Speed>
            )
            speed += 0.1;
            speed = Math.round(speed * 10) / 10;
            if (speed > 2.0) {
                break;
            }
        }
        return selector;
    }

    render() {
        // header:110 title:40 play:50 test:50 footer:50
        const height = (window.innerHeight - 110 - 40 - 50 - 50 - 50) + "px";
        const btn_on = (
            <i className="fas fa-toggle-on fa-rotate-180"></i>
        );
    
        const btn_off = (
            <i className="fas fa-toggle-on"></i>
        );

        const propsScroll = {
            width: '100%',
            height: height,
            contents: this.createText()
        }
        const imgEn = this.state.displayEnglish ? btn_on : btn_off;
        const imgJa = this.state.displayJapanese ? btn_on : btn_off;
        const speed = this.state.playbackRate.toFixed(1);

        let playIcon;
        let testIcon;
        if (this.state.executeAutoPlay) {
            playIcon = (
                <Control onClick={this.onClickAllStop}>
                    <ControlIcon>
                        <i className="fas fa-stop"></i>
                    </ControlIcon>
                    <div>
                        停止する
                    </div>
                </Control>
            );
        } else {
            playIcon = (
                <Control onClick={e => this.onClickAllPlay(e, 0)}>
                    <ControlIcon>
                        <i className="fas fa-play"></i>
                    </ControlIcon>
                    <div>
                        英語をまとめて再生する
                    </div>
                </Control>
            );
        }
        if (this.state.executeTest) {
            testIcon = (
                <Control onClick={this.onClickTestEnd}>
                    <div>
                        終了する
                    </div>
                </Control>
            );
        } else {
            testIcon = (
                <Control onClick={e => this.onClickTest(e, 0)}>
                    <div>
                        サイトラ（オート再生）
                    </div>
                </Control>
            );
        }
        let manualIcon =  (
            <Control onClick={e => this.onClickTapPlay(e)}>
                <div>
                    {this.state.executeTap ? '次のチャンクへ' : 'サイトラ（タップ再生）'}
                </div>
            </Control>
        );

        return (
            <Body Width={this.props.width} Height={this.props.height}>
                <Titles>
                    <Languagewrap>
                        <Language type={1}>
                            英語
                        </Language>
                        <LanguageControl onClick={e => this.onClickLanguage(e, 0)}>
                            ON
                            <LanguageChildImg>{imgEn}</LanguageChildImg>
                            OFF
                        </LanguageControl>
                        <Language>
                            日本語
                        </Language>
                        <LanguageControl onClick={e => this.onClickLanguage(e, 1)}>
                            ON
                            <LanguageChildImg>{imgJa}</LanguageChildImg>
                            OFF
                        </LanguageControl>
                    </Languagewrap>
                </Titles>
                <PlayControls>
                    <PlayControl>
                        {playIcon}
                    </PlayControl>
                    <SpeedControlWrap>
                        <SpeedControl onClick={this.onClickSettingbutton}>
                            <SpeedIcon>
                                <img src={speedIcon} alt="img" width="20px" height="20px" />
                            </SpeedIcon>
                            <TextField>
                                ×{speed}
                            </TextField>
                        </SpeedControl>

                        <Setting setting={this.state.setting}>
                            <Selector>{this.createSpeedSelector()}</Selector>
                        </Setting>
                    </SpeedControlWrap>
                </PlayControls>

                <ScrollView ref={this.refScroll} {...propsScroll} />
                <TestControls>
                    <TestControl>
                        {testIcon}
                    </TestControl>
                    <TestControl>
                        {manualIcon}
                    </TestControl>
                </TestControls>
                <audio ref={this.refAudio} autobuffer="true" id="audio" onEnded={this.onEnded} />
                <Loading Display={this.state.loading}>
                    <LoadingText>音声ファイル取得中</LoadingText>
                </Loading>
            </Body>
        );
    }
}

export { Training3 };

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: relative;
`;
const Titles = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 39px;
    align-items: center;
    border-bottom: 1px solid #dddddd;
`;

const WordRow = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    background-color: ${props => props.active ? '#eaf3ff' : 'transparent'};
    transition-duration:0.3s;
    transition-timing-function: ease-in-out;
    
    font-size: 20px;

    position: relative;
`;
const WordRowIcon = styled.div`
    position: absolute;
    top: 50%;
    left: -20px;
    transform: translateY(-50%);
    color: #0077FF;
    font-weight: 400;
`;
const WordRowChild = styled.div`
    opacity: ${props => props.Display ? '1' : '0'};
    will-change: opacity;
    transition-duration: 0.3s;
`;

const Word = styled.div`
    min-height: 40px;
    padding: 3px 6px;
    display: flex;
    justify-content: start;
    align-items: center;
    margin-left: 40px;
    color: ${props => props.type ? '#0077FF' : '#000'};
    opacity: ${props => props.Display ? '1' : '0'};
    transition-duration: 0.3s;

    position: relative;
`;

const Languagewrap = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 20px;
`;

const Language = styled.div`
    color: ${props => props.type ? '#0077FF' : '#000'};
`;

const LanguageControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 15px;
    line-height: 30px;
    margin: auto 10px;
`;

const LanguageChildImg = styled.div`
    flex: 1;
    text-align: center;
    display: block;
    margin: auto 2px;
    font-size: 30px;
    color: #0077FF;
`;

const PlayControls = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    align-items: center;
`;

const PlayControl = styled.div`
    width: 180px;
    height: 30px;
    color: #000;
    background-color: #eeeeee;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin-left: 20px;
    margin-right: 20px;
`;

const TestControls = styled.div`
    display: flex;
    height: 50px;
    align-items: center;
    padding: 0 4px;
    column-gap: 4px;
`;

const TestControl = styled.div`
    width: 200px;
    height: 30px;
    color: #fff;
    background-color: #0077FF;
    justify-content: center;
    margin: 5px auto;
    align-items: center;
    text-align: center;
    border-radius: 5px;
    font-size: 15px;
`;

const Control = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    :nth-of-type(n+2) {
        border-left: 1px solid #fff;
    }
`;

const ControlIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    color: #0077FF;
    margin-right: 5px;
`;

const Loading = styled.div`
    display: ${props => props.Display ? "" : "none"};
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    position: absolute;
    top: 0;
    left: 0;
`;

const anime = keyframes`
    0% {border: 1px solid #ddd; color: #ddd;}
   50% {border: 1px solid #0077ff; color: #0077ff;}
  100% {border: 1px solid #ddd; color: #ddd;}
`;

const LoadingText = styled.div`
    border: 1px solid #ddd;
    color: #ddd;
    border-radius: 20px;
    background-color: #fff;
    padding: 5px 20px;
    text-align: center;
    position: absolute;
    top: 50px;
    left: 50%;
    max-width: 60%;
    transform: translateX(-50%);
    animation: ${anime} linear 2s;
    animation-iteration-count: infinite;
`;

const SpeedControlWrap = styled.div`
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #eeeeee;
    border-radius: 20px;
    padding: 3px 1px;
    width: 80px;
    font-size: 18px;
`;
const SpeedControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
`;
const SpeedIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: #0077FF;
    font-size:18px;
`;
const TextField = styled.div`
    margin-bottom: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 20px;
`;
const Speed = styled.div`
    text-align: center;
`;
const Selector = styled.div`
    background-color: #eeeeee;
    border-radius: 5px;
    min-width: 100px;
    height: 200px;
    overflow: auto;
    box-shadow: 0 0 6px rgba(0,0,0,0.3);
`;
const Setting = styled.div`
    position: absolute;
    margin-top: ${props => (props.setting ? '0' : '5px')};
    transform: translate(10%, 60%);
    opacity: ${props => (props.setting ? '1' : '0')};
    transition-duration: 0.2s;

    display: flex;
    justify-content: space-around;
    width: 90px;
    pointer-events: ${props => (props.setting ? '' : 'none')};
    z-index: 99;
`;